export type ThemeName = 'default' | 'dark';

export function loadTheme(name: ThemeName) {
  document.documentElement.setAttribute('data-theme', name === 'dark' ? 'dark' : '');
  localStorage.setItem('cbt-v2-theme', name);
}

export function getCurrentTheme(): ThemeName {
  return (localStorage.getItem('cbt-v2-theme') as ThemeName) || 'default';
}
